import React from 'react';
import { StyledText, TabTriggerButton } from './Tab.styled';
import { Flex } from '../Flex/Flex';
import { Box } from '../Box/Box';
export const TabButton = ({
  border,
  tab,
  size,
  isTransparent,
  dynamicTabWidth,
  onTabSelect
}) => {
  return React.createElement(TabTriggerButton, {
    dynamicTabWidth: dynamicTabWidth,
    isTransparent: isTransparent,
    buttonBorder: border,
    value: `tab-${tab.id}`,
    key: `tab-${tab.id}`,
    onClick: () => onTabSelect()
  }, tab.icon ? React.createElement(React.Fragment, null, React.createElement(Flex, {
    alignItems: 'center',
    justifyContent: 'center'
  }, React.createElement(Box, null, React.createElement(tab.icon, {
    title: tab.icon.name,
    marginLeft: '14px',
    size: 24
  })), React.createElement(StyledText, {
    icon: tab.icon,
    size: size,
    textStyle: 'paragraph'
  }, tab.text))) : React.createElement(StyledText, {
    size: size,
    textStyle: 'paragraph'
  }, tab.text));
};